import { render, staticRenderFns } from "./newPrintTag.vue?vue&type=template&id=6cb6a33c&"
import script from "./newPrintTag.vue?vue&type=script&lang=js&"
export * from "./newPrintTag.vue?vue&type=script&lang=js&"
import style0 from "./newPrintTag.vue?vue&type=style&index=0&id=6cb6a33c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports